import React from 'react';
import css from './OrderPanel.module.css';
import { Card } from '../Card/Card';
import { AvatarMedium } from '../Avatar/Avatar';
import { LocationTag } from '../Tag/TagComponent';
import { BackgroundCheckIcon } from '../BackgroundCheckIcon/BackgroundCheckIcon';
import { PrimaryButton } from '../Button/Button';
import { FormattedMessage } from 'react-intl';
import ExpandingTextarea from '../ExpandingTextarea/ExpandingTextarea';
import { getTransactionTypeData } from '../../containers/CheckoutPage/CheckoutPageTransactionHelpers';
import { useHistory } from 'react-router-dom';
import { useState } from 'react';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { pathByRouteName } from '../../util/routes';
import { useConfiguration } from '../../context/configurationContext';
import Icon from '../Icon/Icon';
import { OrganizationBadge } from '../OrganizationBadge/OrganizationBadge';

export const ContactPanel = ({ author, listing, publicData, onInquiryWithoutPayment }) => {
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState('');
  const history = useHistory();

  const routeConfiguration = useRouteConfiguration();
  const config = useConfiguration();
  const isOrganization =
    publicData?.i_am_agency === 'yes' && publicData?.organization_name?.length > 0;
  const isBackgroundCheck = publicData?.background_check === 'yes';

  const onSubmit = () => {
    if (message.length < 2) {
      return;
    }
    const { listingType, transactionProcessAlias, unitType } =
      listing?.attributes?.publicData || {};

    const inquiryParams = {
      listingId: listing?.id,
      protectedData: {
        inquiryMessage: message,
        ...getTransactionTypeData(listingType, unitType, config),
      },
    };

    onInquiryWithoutPayment(
      inquiryParams,
      transactionProcessAlias,
      'transition/inquire-without-payment'
    )
      .then(transactionId => {
        setSubmitting(false);

        const orderDetailsPath = pathByRouteName('OrderDetailsPage', routeConfiguration, {
          id: transactionId.uuid,
        });
        history.push(orderDetailsPath);
      })
      .catch(err => {
        console.error(err);
        setSubmitting(false);
      });
  };

  return (
    <Card>
      <div className={css.wrapper}>
        <div className={css.header}>
          <Icon icon={'Phone'} />
          {'Contact me'}
        </div>
        <div className={css.contactAuthorSection}>
          <AvatarMedium user={author} />
          <div
            className={css.column}
            style={{
              gap: 6,
            }}
          >
            <div
              className={css.row}
              style={{
                gap: 6,
              }}
            >
              <div className={css.name}>
                {isOrganization
                  ? publicData?.organization_name
                  : author?.attributes?.profile?.displayName}
              </div>
              {isOrganization && <OrganizationBadge />}
              {isBackgroundCheck && <BackgroundCheckIcon />}
            </div>
            <div>
              <LocationTag text={publicData?.location?.address} />
            </div>
          </div>
        </div>
        <div>
          <label htmlFor="contactArea">
            <FormattedMessage id="Cappa.labelYourMessage" />
          </label>
          <ExpandingTextarea
            id="contactArea"
            value={message}
            onChange={e => {
              setMessage(e.target.value);
            }}
          />
        </div>
        <PrimaryButton
          onClick={() => {
            onSubmit();
          }}
        >
          <FormattedMessage id="Cappa.sendMessage" />
        </PrimaryButton>
      </div>
    </Card>
  );
};
